import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Stack, TextField } from '@mui/material';
import React, { useState } from 'react';

import TARGETING_TACTICS from '../../../constants/adGroupTargeting';
import TacticsPicker from './TacticsPicker';

interface TacticsSearchProps {
  tactics: string[];
}

function TacticsSearch({ tactics }: TacticsSearchProps) {
  const [keyword, setKeyword] = useState('');
  const matchingTactics = tactics.filter(
    (key) => keyword !== '' && TARGETING_TACTICS[key].label.toLowerCase().indexOf(keyword.toLowerCase()) >= 0
  );
  return (
    <Stack spacing={2}>
      <TextField
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        placeholder="Search ..."
        size="small"
        InputProps={{
          endAdornment: keyword ? (
            <ClearIcon sx={{ mr: 1 }} onClick={() => setKeyword('')} />
          ) : (
            <SearchIcon sx={{ mr: 1 }} />
          ),
        }}
      />
      <TacticsPicker tactics={matchingTactics} />
    </Stack>
  );
}

export default TacticsSearch;
